import { State } from '../state';
import { selectBpmnProcessState } from './bpmn-process-state.selector';
import { createSelector, MemoizedSelector } from '@ngrx/store';

const getPatientData = (state: State): any => state.patientData;
export const selectPatientData: MemoizedSelector<
  object,
  any
  > = createSelector(selectBpmnProcessState, getPatientData);



